<template>
  <VueSlider class="ts-slider-2" v-bind="$attrs" v-on="$listeners"></VueSlider>
</template>

<style lang="scss" scoped>
.ts-slider-2::v-deep {
  /* component style */
  .vue-slider-disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* rail style */
  .vue-slider-rail {
    background-color: #e4e7ed;
    border-radius: 15px;
  }

  /* process style */
  .vue-slider-process {
    background-color: #99ffd1;
    border-radius: 15px;
  }

  /* mark style */
  .vue-slider-mark {
    z-index: 4;
  }
  .vue-slider-mark:first-child .vue-slider-mark-step,
  .vue-slider-mark:last-child .vue-slider-mark-step {
    display: none;
  }
  .vue-slider-mark-step {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.16);
  }
  .vue-slider-mark-label {
    font-size: 14px;
    white-space: nowrap;
  }
  /* dot style */
  .vue-slider-dot-handle {
    cursor: grab;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: #ebecf0;
    background-image: linear-gradient(-42deg, #000000 0%, #ffffff 100%);
    background: #99ffd1;
    border: 2px solid rgba(255, 255, 255, 0.32);
    box-shadow: -6px -6px 16px 0 rgba(250, 251, 255, 0.4), 6px 6px 16px 0 rgba(166, 171, 189, 0.4);
  }
  .vue-slider-dot-handle-focus {
    box-shadow: 0px 0px 1px 2px rgba(153, 255, 209, 0.36);
  }

  .vue-slider-dot-handle-disabled {
    cursor: not-allowed;
    background-color: #e4e7ed;
  }

  .vue-slider-dot-tooltip-inner {
    background: #ebecf0 !important;
    background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.32);
    box-shadow: -6px -6px 16px 0 rgba(250, 251, 255, 0.4), 6px 6px 16px 0 rgba(166, 171, 189, 0.4);
    border-radius: 13px;

    font-family: Roboto;
    font-size: 10px;
    text-align: center;
    color: #acbacc;
  }
  .vue-slider-dot-tooltip-inner::after {
    content: '';
    position: absolute;
  }
  .vue-slider-dot-tooltip-inner-top::after {
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0);
    height: 0;
    width: 0;
    border-color: transparent;
    border-style: solid;
    border-width: 5px;
    border-top-color: inherit;
  }
  .vue-slider-dot-tooltip-inner-bottom::after {
    bottom: 100%;
    left: 50%;
    transform: translate(-50%, 0);
    height: 0;
    width: 0;
    border-color: transparent;
    border-style: solid;
    border-width: 5px;
    border-bottom-color: inherit;
  }
  .vue-slider-dot-tooltip-inner-left::after {
    left: 100%;
    top: 50%;
    transform: translate(0, -50%);
    height: 0;
    width: 0;
    border-color: transparent;
    border-style: solid;
    border-width: 5px;
    border-left-color: inherit;
  }
  .vue-slider-dot-tooltip-inner-right::after {
    right: 100%;
    top: 50%;
    transform: translate(0, -50%);
    height: 0;
    width: 0;
    border-color: transparent;
    border-style: solid;
    border-width: 5px;
    border-right-color: inherit;
  }

  .vue-slider-dot-tooltip-wrapper {
    opacity: 0;
    transition: all 0.3s;
  }
  .vue-slider-dot-tooltip-wrapper-show {
    opacity: 1;
  }
}
</style>

<script>
import VueSlider from 'vue-slider-component';
// import 'vue-slider-component/theme/default.css';

export default {
  name: 'TsSlider2',
  components: {
    VueSlider
  }
};
</script>
